import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { breakpoints, ECOMMERCE_PLANALTO_URL } from '../../constants'
import Browser from '../../services/Browser'
import AnchorButton from '../buttons/anchor-button.component'
import Logomark from './logomark.component'

export const cardDestinoDisplayGrid = () => `
    @media (min-width: ${breakpoints.MOBILE}px) {
        display: grid;
        grid-template: repeat(2, auto) / repeat(2, 1fr);
        grid-gap: 2.5rem;

        ${
				Browser.isIE()
					? `
                display: flex;
                flex-wrap: wrap;
            `
					: null
			};

        a {
			transition: transform 0.5s;
            grid-area: auto;

            ${
					Browser.isIE()
						? `
                margin-bottom: 3rem;
				width: 40%;
            `
						: null
				}
        }

        &.visible {
            a {
                &:nth-child(even) {
                    transform: translateY(-5rem);
                }

                ${
							Browser.isIE()
								? `
                    &:nth-child(odd) {
                        margin-right: 3rem;
                    }                `
								: null
						}
            }
        }
    }
`

const StyledCardDestino = styled.div`
	box-shadow: 0 6px 40px 15px rgba(0, 0, 0, 0.1);
	display: inline-block;
	transition: transform 0.5s;

	img {
		height: 202px;
		object-fit: cover;
		max-width: 100%;
		width: ${Browser.isIE() ? '100%' : '270px'};
	}

	.title {
		color: #000;
		font-size: 20px;
		text-align: left;
		background: #fff;
		padding: 4rem 2.5rem;
		position: relative;

		.logo {
			max-height: 16px;
			position: absolute;
			top: 1rem;
			right: 0;
			transform: scale(0.45);
		}
	}
`

const CardDestino = ({ destino }) => (
	<AnchorButton href={ECOMMERCE_PLANALTO_URL} noStyle targetBlank>
		<StyledCardDestino className="img-card">
			<img src={destino.image} alt={destino.name} />
			<div className="title">
				{destino.name}
				{destino.points && (
					<div className="blue">A partir de {destino.points} pontos</div>
				)}
				<Logomark size={''}/>
			</div>
		</StyledCardDestino>
	</AnchorButton>
)

CardDestino.propTypes = {
	destino: PropTypes.shape({
		name: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired
	}).isRequired
}

export default CardDestino
